import { Key, ReactNode } from 'react'

import { Collapse } from 'antd'

export interface PanelProps {
  key?: Key
  header: string | ReactNode
  content: ReactNode
  extra?: ReactNode
  showArrow?: boolean
  disabled?: boolean
  className?: string
}

const CollapseItem = (props: PanelProps) => {
  return (
    <Collapse.Panel key={props.key} {...props}>
      {props.content}
    </Collapse.Panel>
  )
}

export default CollapseItem
